import { render, staticRenderFns } from "./PxListaSelecaoTransportador.vue?vue&type=template&id=8a31c622&"
import script from "./PxListaSelecaoTransportador.vue?vue&type=script&lang=js&"
export * from "./PxListaSelecaoTransportador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports